(function(global) {
  'use strict';

  var RATE_CENTS_PER_SQUARE_INCH = 8;
  var MINIMUM_ORDER_CENTS = 1000;
  var MAX_WIDTH_INCHES = 25;
  var MAX_HEIGHT_INCHES = 240;

  function finiteNumber(value) {
    if (value === '' || value === null || typeof value === 'undefined') return null;
    var number = Number(value);
    return Number.isFinite(number) ? number : null;
  }

  function calculateArtwork(input) {
    input = input || {};
    var errors = [];
    var width = finiteNumber(input.width);
    var height = finiteNumber(input.height);
    var quantity = finiteNumber(input.quantity);

    if (!input.artworkPresent || !String(input.artworkName || '').trim()) {
      errors.push('Choose an artwork file.');
    }
    if (width === null || width < 1 || width > MAX_WIDTH_INCHES) {
      errors.push('Enter a width from 1 to 25 inches.');
    }
    if (height === null || height < 1 || height > MAX_HEIGHT_INCHES) {
      errors.push('Enter a length from 1 to 240 inches.');
    }
    if (quantity === null || quantity < 1 || !Number.isInteger(quantity)) {
      errors.push('Enter a whole-number transfer quantity of at least 1.');
    }

    if (errors.length) {
      return {
        valid: false,
        errors: errors,
        artworkName: String(input.artworkName || ''),
        quoteTotalCents: 0,
        customerQuantity: quantity
      };
    }

    var areaSquareInches = width * height;
    var unroundedPriceEachCents = areaSquareInches * RATE_CENTS_PER_SQUARE_INCH;
    var quoteTotalCents = Math.round(unroundedPriceEachCents * quantity);

    return {
      valid: true,
      errors: [],
      artworkName: String(input.artworkName),
      width: width,
      height: height,
      areaSquareInches: areaSquareInches,
      customerQuantity: quantity,
      rateCentsPerSquareInch: RATE_CENTS_PER_SQUARE_INCH,
      priceEachCents: unroundedPriceEachCents,
      quoteTotalCents: quoteTotalCents,
      tier: 'flat-no-tier'
    };
  }

  function calculateOrder(inputs) {
    var source = Array.isArray(inputs) ? inputs : [];
    var records = source.map(calculateArtwork);
    var errors = [];

    if (!records.length) errors.push('Choose at least one artwork file.');
    records.forEach(function(record, index) {
      if (!record.valid) {
        record.errors.forEach(function(error) {
          errors.push('Artwork ' + (index + 1) + ': ' + error);
        });
      }
    });

    var valid = records.length > 0 && errors.length === 0;
    var totalCents = valid ? records.reduce(function(sum, record) {
      return sum + record.quoteTotalCents;
    }, 0) : 0;
    var eligible = valid && totalCents >= MINIMUM_ORDER_CENTS;

    return {
      valid: valid,
      eligible: eligible,
      errors: errors,
      records: records,
      totalCents: totalCents,
      chargeCents: valid ? totalCents : 0,
      remainingCents: valid ? Math.max(0, MINIMUM_ORDER_CENTS - totalCents) : MINIMUM_ORDER_CENTS,
      minimumOrderCents: MINIMUM_ORDER_CENTS
    };
  }

  global.TwistedSwagDtfPricing = Object.freeze({
    RATE_CENTS_PER_SQUARE_INCH: RATE_CENTS_PER_SQUARE_INCH,
    MINIMUM_ORDER_CENTS: MINIMUM_ORDER_CENTS,
    MAX_WIDTH_INCHES: MAX_WIDTH_INCHES,
    MAX_HEIGHT_INCHES: MAX_HEIGHT_INCHES,
    calculateArtwork: calculateArtwork,
    calculateOrder: calculateOrder
  });
})(window);
